var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pages-ccd-company-detail" },
    [
      _c("div", { staticClass: "page-head-container" }, [
        _c("div", { staticClass: "page-head clearfix" }, [
          _c("div", { staticClass: "page-head-info columns clearfix" }, [
            _c("div", { staticClass: "nav-bar" }, [
              _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      return _vm.navBack()
                    },
                  },
                },
                [_vm._v("\n            < " + _vm._s(_vm.$t("back")))]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "page-head-project-info clearfix" }, [
              _vm.currentCompany.id
                ? _c("div", { staticClass: "page-project-number" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$i18n.t("company.companyNumber")) +
                        " " +
                        _vm._s(_vm.currentCompany.id || "") +
                        "\n          "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row page-project-name" }, [
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.currentCompany.name || _vm.$t(_vm.description))
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "float-right clearfix" }, [
              _vm.allowEditCompany && !_vm.allowEdit
                ? _c(
                    "button",
                    {
                      directives: [
                        { name: "hkldreset", rawName: "v-hkldreset" },
                      ],
                      staticClass: "btn btn--orange",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.enableEdit()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("action.edit")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.allowEdit
                ? _c(
                    "button",
                    {
                      directives: [
                        { name: "hkldreset", rawName: "v-hkldreset" },
                      ],
                      staticClass: "btn btn--darkblue",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.cancelEdit()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("action.cancel")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.allowEdit
                ? _c(
                    "button",
                    {
                      directives: [
                        { name: "hkldreset", rawName: "v-hkldreset" },
                      ],
                      staticClass: "btn btn--orange",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("action.save")))]
                  )
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("CompanyInformation", {
        ref: "companyInformation",
        attrs: { allowEdit: _vm.allowEdit },
      }),
      _vm._v(" "),
      _vm.showPerformance ? _c("VendorPerformance") : _vm._e(),
      _vm._v(" "),
      _vm.showTenancyRecord
        ? _c("CompanyTenancyRecord", {
            attrs: {
              allowCreate: _vm.allowCreateTenancyRecord,
              tenancies: _vm.tenancies,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.currentCompany.id
        ? _c("CompanyContact", { attrs: { allowEdit: _vm.allowEdit } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }